import { FieldValues } from "react-hook-form";

import { SelectProps as SelectFieldProps } from "components/ui/select/Select";
import SkeletonText from "components/ui/skeleton/SkeletonText";
import { useBidResponseWorkflow } from "lib/hooks/api/bid/bid_responses/useBidResponseWorkflow";
import { processTransitions } from "../../../shared/stage/utils";
import { StageSelect } from "./StageSelect";

export function BidResponseStageSelect<TFieldValues extends FieldValues = FieldValues>(
  props: Omit<SelectFieldProps<TFieldValues>, "children">,
) {
  const { data, isLoading } = useBidResponseWorkflow();

  const flatOptions = data?.transitions
    ? processTransitions(data.transitions).flatMap((group) => group.options)
    : [];

  if (isLoading) {
    return <SkeletonText width="200px" />;
  }

  return <StageSelect {...props} options={flatOptions} />;
}
